<template>
    <div>
        <slot name="title"></slot>

        <br class="mb-3"/>

        <select-as-radio-field
            v-model="hasElements"
            :field="{label: $t('finalevaluation.hasOutpatientTreatments')}"
            class="text-center mb-5"
            field-name="has-outpatient-treatment"
            yes-no
        />

        <div v-if="hasElements" class="mb-3">
            <div
                v-for="(outpatientTreatment, index) in $v.elements.$each.$iter"
                :key="index"
                class="mx-3 mb-5"
            >
                <multiple-card-item
                    :title="$t('finalevaluation.outpatientTreatment')"
                    @delete="deleteElement(index)"
                >
                    <select-as-radio-field
                        v-model="outpatientTreatment.treatment_type.$model"
                        :field="outpatientTreatmentsFields.treatment_type"
                        :field-name="'outpatient-treatment-type-'+ index"
                        :errors="outpatientTreatment.treatment_type.$invalid ? {['outpatient-treatment-type-'+ index]: $t('error.required')} : {}"
                    />

                    <input-field
                        v-model="outpatientTreatment.days.$model"
                        :field="outpatientTreatmentsFields.days"
                        :field-name="'outpatient-treatment-days-'+ index"
                        :errors="outpatientTreatment.days.$invalid ? {['outpatient-treatment-days-'+ index]: $t('error.required')} : {}"
                        type="number"
                    />

                    <input-field
                        v-if="outpatientTreatment.treatment_type.$model === 'novoeight'"
                        v-model="outpatientTreatment.amount.$model"
                        :field="outpatientTreatmentsFields.amount"
                        :field-name="'outpatient-treatment-dose-'+ index"
                        type="number"
                        show-help-as-unit
                    />
                </multiple-card-item>
            </div>

            <div class="text-center">
                <hemocir-button
                    :title="$t('finalevaluation.addOutpatientTreatment')"
                    font-awesome-icon="fa-plus-circle"
                    variant="outline-gray"
                    @click="addElement"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import NavigableComponentMixin from "@/components/mixins/NavigableComponentMixin";
    import {cloneDeep} from "lodash";
    import {required} from "vuelidate/lib/validators";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import InputField from "@/components/fields/InputField";
    import MultipleCardItem from "@/components/MultipleCardItem";
    import ScrollToErrorMixin from "@/components/mixins/ScrollToErrorMixin";
    import QuestionWithMultipleElementsMixin from "@/components/mixins/QuestionWithMultipleElementsMixin";

    export default {
        name: "FinalEvaluationOutpatient",
        components: {MultipleCardItem, InputField, SelectAsRadioField},
        mixins: [NavigableComponentMixin, ScrollToErrorMixin, QuestionWithMultipleElementsMixin],
        computed: {
            ...mapState([
                'finalEvaluation',
                'finalEvaluationFields',
            ]),
            ...mapStateProperty([
                {path: 'finalEvaluation.outpatient_treatments', name: 'finalEvaluationOutpatientTreatments'},
            ]),
            outpatientTreatmentsFields() {
                return this.finalEvaluationFields.outpatient_treatments.child.children;
            }
        },
        created() {
            if (this.finalEvaluationOutpatientTreatments.length > 0) {
                this.hasElements = true;
                this.elements = cloneDeep(this.finalEvaluationOutpatientTreatments);
            }
        },
        methods: {
            validate() {
                this.$v.$touch();
                let isValid = !this.$v.$invalid;
                if (isValid) {
                    this.storeOutpatientTreatments();
                } else {
                    this.$nextTick(this.scrollToError);
                }
                return isValid;
            },
            back() {
                this.storeOutpatientTreatments();
            },
            storeOutpatientTreatments() {
                if (this.hasElements !== true) {
                    this.finalEvaluationOutpatientTreatments = [];
                } else {
                    this.finalEvaluationOutpatientTreatments = cloneDeep(this.elements);
                }
            },
            addElement() {
                this.elements.push({
                    treatment_type: null,
                    days: null,
                    amount: null,
                });
            },
        },
        validations: {
            elements: {
                $each: {
                    treatment_type: {
                        required
                    },
                    days: {
                        required,
                    },
                    amount: {}
                }
            }
        }
    };
</script>

<style scoped>

</style>